import IconWrapper from "@components/svg_icon_wrapper"

export default function QLightLogo() {
  return (
    <IconWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="28.942"
        viewBox="0 0 30 28.942"
      >
        <path
          id="Path_2"
          data-name="Path 2"
          d="M44.8,35.62a9.61,9.61,0,0,0,.558-.832l.007-.01c0-.007.008-.016.011-.023.051-.088.1-.163.159-.277l-.022.012a12.949,12.949,0,0,0,1.714-6.55,12.605,12.605,0,0,0-4.265-9.768,15.392,15.392,0,0,0-10.735-3.86A15.4,15.4,0,0,0,21.5,18.172a12.6,12.6,0,0,0-4.265,9.768A12.99,12.99,0,0,0,22.992,38.9a15.09,15.09,0,0,0,6.25,2.43,19.834,19.834,0,0,0,3.238.255c.068,0,.131-.006.2-.007.138,0,.27-.01.406-.015q.575-.021,1.129-.076c.1-.01.2-.02.3-.031a15.639,15.639,0,0,0,6.8-2.489,19.941,19.941,0,0,1-3.03,2.356s1.243,1.241,6.1,1.877c.189.025,2.184.367,1.287-.988C45.432,41.766,42.342,39.251,44.8,35.62Zm-18.25.081a9.085,9.085,0,0,1-4.714-7.229c-.328-5.16,4.111-9.627,9.917-9.976s10.778,3.551,11.106,8.711c.3,4.658-3.3,8.739-8.268,9.749a12.387,12.387,0,0,0,2.312.491,13.81,13.81,0,0,1-8.835-1.016,10.841,10.841,0,0,1-1.5-.722Zm.25-8.771a1.114,1.114,0,1,0,1.223,1.109A1.17,1.17,0,0,0,26.8,26.929Zm11.1,0a1.114,1.114,0,1,0,1.223,1.109,1.17,1.17,0,0,0-1.223-1.109Zm-5.551,0a1.114,1.114,0,1,0,1.223,1.109,1.17,1.17,0,0,0-1.223-1.109Z"
          transform="translate(-17.232 -14.312)"
          fill="#fff"
        />
      </svg>
    </IconWrapper>
  )
}
